import React, { lazy, Suspense } from 'react';
import SkeletonGrid from '../../../skeleton_loaders/common/SkeletonGrid.jsx';
import ButtonSkeleton from '../../../skeleton_loaders/common/ButtonSkeleton.jsx';
import SkeletonComponent from '../../../skeleton_loaders/common/SkeletonComponent.jsx';

const Content = lazy(() => import('./JsonBuilderForm.jsx'));

const JsonConfigSkeleton = () => {
  return (
    <>
      <div className='d-flex mb-1 mt-1' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <div className='d-flex' style={{width: '100%', justifyContent: 'flex-start', alignItems: 'center' }}>
          <label style={{width: '100%'}}><SkeletonComponent width='70%' /></label>
        </div>
        <div className='d-flex' style={{width: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
          <ButtonSkeleton size='sm' className='ml-1' buttonContent={I18n.t('format_json')} />
          <ButtonSkeleton size='sm' className='ml-1' buttonContent={I18n.t('get_default_example_data')} />
        </div>
      </div>
      <SkeletonGrid gridHeight={40} />
    </>
  );
};

const JsonBuilderSkeleton = ({fields}) => {
  return (
    <>
      {fields.map((_, i) => <JsonConfigSkeleton key={`json-config-${i}`} />)}
      <div className='actions' style={{width: '100%'}}>
        <ButtonSkeleton size='md' className='pull-right' buttonContent={I18n.t('save')} />
        <ButtonSkeleton size='md' className='mr-1 pull-right' buttonContent={I18n.t('cancel')} />
      </div>
    </>
  )
}

const JsonBuilderForm = ({ open = true, ...props }) => {
  if (!open) return null;

  return (
    <Suspense fallback={<JsonBuilderSkeleton fields={props.fields} />}>
      <Content {...props}/>
    </Suspense>
  )
}

export default JsonBuilderForm;
